<template lang="pug">
    section#juntos
        div.wrapper
            h2 Juntos, vamos aprender.
            h2 Juntos, vamos superar.

            p
                | A #[strong.fael= "UniFAEL"] promoverá a “1ª Jornada Nacional de Extensão Universitária EaD”, que
                | integrará a Mostra de Práticas Extensionistas realizadas com os alunos de todos os
                | cursos da UniFAEL de forma virtual no período de
                strong 22 a 30 de junho de 2020.
            p.menor
                | Este evento será gratuito, para todos os alunos, egressos e comunidade externa, venha participar conosco!
            p.menor
                | #[strong= "Objetivo"]: promover, disseminar e difundir no meio acadêmico a cultura de práticas
                | extensionistas que promovam a formação de profissionais, integrados com a
                | sociedade, e comprometidos com a melhoria da qualidade de vida das regiões onde a
                | #[strong.fael= "UniFAEL"] está inserida.
            p.menor
                | #[strong= "Certificação"]: 35 horas de participação que poderão ser utilizadas para suas atividades complementares.
</template>

<script>
export default {
    name: "section-juntos"
}
</script>

<style lang="stylus" scoped src="./Juntos.styl"></style>
